import * as React from "react"

const Input = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  ({ className, ...props }, ref) => <input ref={ref} className={`input ${className || ""}`} {...props} />,
)
Input.displayName = "Input"

export { Input }
